/**
 * The origin a relative `returnTo` is resolved against. Only ever used to tell "this deployment"
 * apart from "somewhere else"; the resolved path is what gets used, never this host.
 */
const INTERNAL_BASE = 'https://config.invalid';

/**
 * `returnTo` arrives in the query string, so it is attacker controlled. A relative path can only
 * land inside this deployment. An absolute URL leaves it, which is what the way out has to do once
 * configuration is an origin of its own, so it is kept only when the host declared that origin.
 *
 * Resolving through `URL` rather than matching the string is what closes the variants a prefix
 * check misses: `//host`, `/\host` and a scheme with no host all resolve to an origin that is
 * not this deployment.
 */
export const resolveReturnTo = (raw: string | null | undefined, allowedOrigins: string[] = []): string => {
  if (!raw) return '/';

  let url: URL;
  try {
    url = new URL(raw, INTERNAL_BASE);
  } catch {
    return '/';
  }

  if (url.origin === INTERNAL_BASE) return `${url.pathname}${url.search}${url.hash}`;

  return allowedOrigins.includes(url.origin) ? url.href : '/';
};

/** Whether the way out is a route in this deployment rather than a page load. */
export const isInternalReturnTo = (target: string): boolean => target.startsWith('/');
